
  Vue.component('user-invites-list', {
    props: {
      visible: { type: Boolean, default: true },
      selectedId: { type: Number },
      handleReSend: { type: Function, required: true },
      relationshipType: { type: Number }
    },
    data() {
      return {
        formInterfaces: {},
        contactsList: [],

        columnsList: [
          { id: 'ContactEmail', label: 'Email', sortable: true },
          { id: 'CreateDate', label: 'Data contatto', type: 'date', sortable: true }
        ],
        statusList: [
          {
            key: 'registration',
            id: 'RegistrationDone',
            value: 2,
            labelOn: 'Registrazione effettuata',
            labelOff: 'Registrazione non effettuata',
            icon: 'fa-sign-in',
            style: 'warning'
          },
          {
            key: 'registration',
            id: 'ConnectionConfirmed',
            value: 4,
            labelOn: 'Registrazione confermata',
            labelOff: 'Registrazione non confermata',
            icon: 'fa-sign-in',
            style: 'success'
          }
          // {
          //  key: 'link',
          //  id: 'GlobalLinkOpened',
          //  value: 1,
          //  type: 8,
          //  labelOn: 'Link globale aperto',
          //  labelOff: 'Link globale aperto',
          //  icon: 'fa-globe',
          //  style: 'success'
          // }
          // {
          //  key: 'privacy',
          //  id: 'PrivacyAccepted',
          //  value: 8,
          //  labelOn: 'Privacy accettata',
          //  labelOff: 'Privacy non ancora accettata',
          //  icon: 'fa-user-secret'
          // }
        ]
      }
    },
    template: '#user-invites-list',
    computed: {
      uniqueStatusList() {
        return Array.from(new Set(this.statusList.map(item => item.key))).map(item => ({ key: item }))
      },
      actionsList() {
        const defaultAction = [
          { id: 'delete', label: 'Elimina', icon: 'fa-trash', action: this.handleDeleteRow },
          {
            id: 'hurry',
            label: 'Invia nuovo invito',
            icon: 'fa-paper-plane',
            action: this.handleReSend
          }
        ]
        const linkedAction = [
          {
            id: 'widget',
            label: 'Apri profilo candidato',
            icon: 'fa-user',
            action: this.handleOpenProfile,
            showWhen: { RelationshipStatus: 4 }
          }
        ]

        return [...defaultAction, ...linkedAction]
      }
    },
    watch: {},
    methods: {
      handleOpenProfile(event, item) {
        const urlCandidate = `/curriculauser?id=${item.UserId}`
        window.open(urlCandidate, '_blank')
      },
      handleDeleteRow(event, item) {
        EventBus.$emit('vnPopup', {
          style: 'popup',
          message: `Sei sicuro di voler eliminare il contatto selezionato dal tuo elenco di invitati?`,
          actions: [
            { label: 'OK', icon: 'fa-check-circle', action: () => this.deleteRow(event, item), style: 'success' },
            { label: 'Annulla', icon: 'fa-times-circle', style: 'info' }
          ]
        })
      },
      deleteRow(event, item) {
        const self = this
        const id = item.Id
        axios
          .get(`/api/v1/seekers-user-invites/delete/${id}`)
          .then(response => {
            const { data } = response
            this.contactsList = this.contactsList.filter(cl => cl.Id != id)

            EventBus.$emit('vnShow', {
              type: 'success',
              message: `La cancellazione è stata effettuata correttamente.`
            })
          })
          .catch(error => {
            EventBus.$emit('vnShow', {
              type: 'danger',
              message: `Le modifiche non sono state salvate: ${error}`
            })
          })
          .then(() => {
            // always executed
          })
      },
      stopAll(event, id) {
        event.stopPropagation()
        event.preventDefault()
        return false
      },
      beforeEnter: () => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      },
      getFormInterface(formInterface) {
        this.formInterfaces[formInterface.key] = formInterface
      },
      setContactsList(data) {
        const self = this
        self.contactsList = data.map(item => {
          self.statusList.forEach(status => {
            const value = (item.RelationshipStatus & status.value) === status.value
            const checkType = status.hasOwnProperty('type') && status.type === item.RelationshipType
            const label = value ? status.labelOn : status.labelOff
            if (checkType) {
              item[status.key] = { ...status, value, label }
            } else if (!status.hasOwnProperty('type')) {
              item[status.key] = item[status.key] && !value ? item[status.key] : { ...status, value, label }
            }
          })
          return item
        })
      },
      getErrorResponse(error) {
        let retVal = error
        if (error.response) {
          retVal = { status: error.response.status }
          if (error.response.data && error.response.data.error) {
            retVal.error = error.response.data.error
          }
        }
        return retVal
      },
      handleSessionExpired() {
        EventBus.$emit('vnPopup', {
          type: 'danger',
          message: `<p><b>La sessione è scaduta</b></p><p>La pagina verrà ricaricata per permettere di effettuare nuovamente il login</p>`,
          actions: [
            {
              label: 'OK',
              icon: 'fa-check-circle',
              action: () => {
                window.location.reload()
              },
              style: 'danger'
            }
          ]
        })
      }
    },
    mounted() {
      const self = this
      axios
        .get(`/api/v1/seekers-user-invites`)
        .then(response => {
          const { data } = response
          self.setContactsList(data)
          if (self.selectedId)
            setTimeout(
              () => document.getElementById(`row-${self.selectedId}`).scrollIntoView({ behavior: 'smooth' }),
              200
            )
        })
        .catch(error => {
          const errorResponse = self.getErrorResponse(error)
          if ((errorResponse.status = 401)) {
            self.handleSessionExpired()
          } else {
            EventBus.$emit('vnShow', {
              type: 'danger',
              message: `Le modifiche non sono state salvate: ${error}`
            })
            self.nextPage()
          }
        })
        .then(() => {
          // always executed
        })
    },
    beforeDestroy() {
      // EventBus.$off('vnShow', this.vnShow)
    }
  })
